module.exports = __webpack_public_path__ + "img/4-2-4-2-1-preview-KOL-corain-e.86ba1d81.jpg";